<template>
  <el-input
    v-model="currentValue"
    v-bind="$attrs">
    <template slot="append">
      <slot name="append"></slot>
    </template>
  </el-input>
</template>

<script>

export default {
  components: {},
  inject: [],
  inheritAttrs: false,
  props: {
    value: String,
  },
  data () {
    return {}
  },
  computed: {
    currentValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {},
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/packages/sj-question-input/src/SjQuestionInput.vue